//ADAS2のキャンセルコードID一覧
export const ADAS2_CANCEL_CODE_IDS = ['1002'];